var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[(_vm.isManager)?_c('goal-overview'):_vm._e(),_c('personal-goal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }